<app-site-toolbar>
    <a [routerLink]="appUrl" matButton="elevated">Get Started</a>
</app-site-toolbar>
<router-outlet />
